<template>
  <div class="bg-slate-50 min-h-screen">
    <div class="max-w-7xl mx-auto py-8 px-4 print:p-0">
      <ReportLayoutModerno 
        v-if="!loader && !showMessage"
        :prefecture="prefecture"
        :period="convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate)"
      >
        <template v-slot:title>RELATÓRIO GENÉRICO</template>
        
        <GenericReport
          :data="dataReport"
          :filter="filter"
          :prefecture="prefecture"
          ref="allComponent"
        />
      </ReportLayoutModerno>

      <!-- LOADER E MENSAGENS -->
      <div v-if="loader" class="bg-white rounded-xl shadow-sm border border-slate-200 p-12 flex flex-col justify-center items-center">
        <svg class="animate-spin h-10 w-10 text-emerald-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Gerando relatório...</span>
      </div>

      <div v-else-if="showMessage" class="bg-white rounded-xl shadow-sm border border-slate-200 p-12 flex flex-col items-center justify-center text-center">
        <v-icon color="orange" size="48" class="mb-4">mdi-alert-circle-outline</v-icon>
        <p class="font-bold text-slate-700 text-lg mb-2">Ops! Algo deu errado.</p>
        <p class="text-slate-500 max-w-md">{{ message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import GenericReport from "./reportComponent";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";

export default {
  components: { GenericReport, ReportLayoutModerno },
  mixins: [Helpers],
  props: {
    startDate: null,
    endDate: null,
    prefecture_id: null,
    vehicle_id: null,
  },
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    showMessage: false,
    loader: false,
    message: "",
  }),
  created() {
    this.loadGenericReport();
    this.Helpers;
  },
  methods: {
    loadGenericReport() {
      this.message = "";
      this.showMessage = false;
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      (this.filter = {
        startDate: this.startDate,
        endDate: this.endDate,
        prefecture_id: this.prefecture_id,
        vehicle_id: this.vehicle_id,
      }),
        this.$http.post(`/reports/master/generic`, this.filter).then((r) => {
          if (r.data.error) {
            this.message = r.data.error;
            this.showMessage = true;
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          } else {
            this.dataReport = r.data;
            this.$http
              .get(`/prefectures/${this.filter.prefecture_id}`)
              .then((p) => {
                this.prefecture = p.data[0];
                this.loader = false;
                this.$store.dispatch("setLoader", this.loader);
              });
          }
        });
    },
  },
};
</script>

<style>
</style>